
//creamos instancia de incode para poder crear session y posteriormente usar sus moduulos

import { appGlobal } from "../api/appGlobal";

const apiURL = appGlobal.apiIncode;
const apiKey = appGlobal.tokenApi;

const incode = window.OnBoarding.create(
	{
		apiKey: apiKey,
		apiURL: apiURL,
		lang: "es",
		theme: {
			main: {
				borderRadius: "20px",
				color: "white",
				border: "4px solid #299145",
				width: '100%',
				backgroundColor: '#299145',
				background: '#299145'
			},
			mainButton: {
				borderRadius: "20px",
				color: "white",
				border: "4px solid #299145",
				width: '100%',
				backgroundColor: '#299145',
				background: '#299145'
			}
		},
		translations: {
			tutorial: {
				front1: "Confirma que la foto sea clara y legible",
				front2: "",
				back1: "Confirma que la foto sea clara y legible",
				back2: "",
				back3: "",
				selfie1: "Prepárate para la prueba de vida",
				selfie2: "",
				selfie3: "",
				passport1: "Align your passport to the frame and take a photo",
				passport2: "Position just the page with the photo"
			}
		}
	}
);
export default incode;
